import React from 'react';
import "./IngredientForm.css";
import { useState, useRef } from 'react';
import { useData } from "../../DataContext/DataProvider"

/**
 * Form for submitting new ingredients
 * @param handleSubmit sumbit button handler, code in IngredientPage.js 
 * @returns form element
 */

function IngredientForm({ initialIngredient = {
        Ingredient_Name: "",
        Ingredient_Quantity: "",
        Ingredient_Date: new Date()
}, cancelEditing }) {
    const [input, setInput] = useState({
        ...initialIngredient,
        Ingredient_Date: initialIngredient.Ingredient_Date?.toJSON()?.slice(0, 10)
    })
    const formRef = useRef(null);
    const dataContext = useData();

    const handleInput = (e) => {
        const { name, value } = e.target;
        setInput((previousInput) => ({
            ...previousInput,
            [name]: value
        }));
    }
    
    const onSubmit = (e) => {
        //e.preventDefault();
        if(formRef.current.reportValidity()){
            input.Ingredient_Name = input.Ingredient_Name.trim()
            if(initialIngredient.Ingredient_ID)
                dataContext.ingredientsData.changeIngredient(input)
            else
                dataContext.ingredientsData.submitIngredient(input)

            cancelEditing?.()
        }
    }
    
    return (
        <div className={"form-container ingredient-element " +  (cancelEditing ? "visible-element" : "hoverable-element")}>
            <form ref={formRef }>
                <div className="form-element">
                    <label>Ingredient:
                        <input
                            type="text"
                            id="Ingredient_Name"
                            name="Ingredient_Name"
                            value={input.Ingredient_Name}
                            placeholder="Ingredient..."
                            pattern="(?!.*[;]).*"
                            required
                            maxLength="45"
                            onChange={handleInput}
                        />
                    </label>
                </div>
                <div className="form-element">
                    <label>Expiry Date: 
                        <input type="date"
                            id="Ingredient_Date"
                            name="Ingredient_Date"
                            value={input.Ingredient_Date ?? "" }
                            required
                            min={new Date().toJSON().slice(0, 10)}
                            onChange={handleInput} />
                    </label>
                </div>
                <div className="form-element">
                    <label>Quantity (g):
                        <input
                            type="number"
                            id="Ingredient_Quantity"
                            name="Ingredient_Quantity"
                            value={input.Ingredient_Quantity}
                            placeholder="0..."
                            max="2147483647"
                            min="0"
                            required
                            onChange={handleInput}
                            onFocus={e => e.target.select()} />
                    </label>
                </div>
                <div className="form-element button-container">
                    <input type="button" className="button" value="Submit" onClick={ onSubmit } />
                    <input type="button" className="button" value="Reset" onClick={() => {
                        setInput({
                            ...initialIngredient,
                            Ingredient_Date: initialIngredient.Ingredient_Date?.toJSON()?.slice(0, 10)
                        })
                    }} />
                    {cancelEditing ? <input type="button" className="button" value="Cancel" onClick={() => {
                        setInput({
                            ...initialIngredient,
                            Ingredient_Date: initialIngredient.Ingredient_Date?.toJSON()?.slice(0, 10)
                        })
                        cancelEditing?.()
                    }} />  : null}
                </div>
            </form>
            <span style={{ whiteSpace: 'pre-wrap', display: 'block' }}></span>
        </div>
    );
}


export default IngredientForm